import React from 'react';
import {
  Image, StyleSheet, Text, View,
} from 'react-native';
import theme from '../theme';
import { defaultScale } from '../utils/scaling';

interface IProps {
  t(key: string): string;
}

const StartDumbbellAssessment: React.FC<IProps> = ({ t }) => (
  <View style={styles.container}>
    <Image
      source={require('../assets/images/dumbbellAssessment.png')}
      style={styles.image}
      resizeMode='cover'
    />
    <View style={styles.bulletPoints}>
      <View style={styles.bulletPointContainer}>
        <View style={styles.bulletPoint} />
        <Text>
          <Text style={styles.regBulletText}>
            {t('startStrengthAssessmentBulletOne_1')}
          </Text>
          <Text style={styles.boldBulletText}>
            {t('startStrengthAssessmentBulletOne_2')}
          </Text>
          <Text style={styles.regBulletText}>
            {t('startStrengthAssessmentBulletOne_3')}
          </Text>
          <Text style={styles.boldBulletText}>
            {t('startStrengthAssessmentBulletOne_4')}
          </Text>
        </Text>
      </View>
      <View style={styles.bulletPointContainer}>
        <View style={styles.bulletPoint} />
        <Text style={styles.regBulletText}>
          {t('dumbbellsRequiredForAssessment')}
        </Text>
      </View>
      <View style={styles.bulletPointContainer}>
        <View style={styles.bulletPoint} />
        <Text style={styles.regBulletText}>
          {t('doAssessmentAtGym')}
        </Text>
      </View>
    </View>
  </View>
);

export default StartDumbbellAssessment;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  image: {
    width: '100%',
  },
  regBulletText: { ...theme.textStyle.bodyCopyReg },
  boldBulletText: { ...theme.textStyle.bodyCopyBold },
  bulletPoint: {
    height: defaultScale(5),
    width: defaultScale(5),
    borderRadius: defaultScale(2.5),
    backgroundColor: theme.BLACK,
    margin: defaultScale(10),
  },
  bulletPointContainer: {
    flexDirection: 'row',
    marginBottom: defaultScale(10),
    maxWidth: '90%',
  },
  bulletPoints: {
    marginVertical: defaultScale(15),
  },
});
